import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  .ant-divider {\n    margin: 12px 0;\n    border-color: ",
        ";\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from "antd";
import useBooksOrderStore from "src/store/booksOrder";
import styled from "styled-components";
import { useBooks } from ".";
import { OrderSummaryItem } from "../../Package/OrderComponents/OrderSummaryItem";
export const BooksOrderSummaryContainer = styled.div.withConfig({
    componentId: "sc-db641cdb-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_100);
const BooksOrderSummary = ()=>{
    const deliveryFee = useBooksOrderStore((state)=>state.deliveryFee);
    const originalPriceTotal = useBooksOrderStore((state)=>state.originalPriceTotal);
    const discountAmount = useBooksOrderStore((state)=>state.discountAmount);
    const payableAmount = useBooksOrderStore((state)=>state.payableAmount);
    const { isBooks  } = useBooks();
    return /*#__PURE__*/ _jsxs(BooksOrderSummaryContainer, {
        children: [
            isBooks && /*#__PURE__*/ _jsxs(OrderSummaryItem, {
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        children: "배송비"
                    }),
                    /*#__PURE__*/ _jsxs("dd", {
                        children: [
                            deliveryFee.toLocaleString(),
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(OrderSummaryItem, {
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        children: "총 상품 금액"
                    }),
                    /*#__PURE__*/ _jsxs("dd", {
                        children: [
                            originalPriceTotal.toLocaleString(),
                            "원"
                        ]
                    })
                ]
            }),
            !!discountAmount && /*#__PURE__*/ _jsxs(OrderSummaryItem, {
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        children: "총 할인 금액"
                    }),
                    /*#__PURE__*/ _jsxs("dd", {
                        className: "discount",
                        children: [
                            "-",
                            discountAmount.toLocaleString(),
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsxs(OrderSummaryItem, {
                children: [
                    /*#__PURE__*/ _jsx("dt", {
                        children: "최종 결제 금액"
                    }),
                    /*#__PURE__*/ _jsx("dd", {
                        children: /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                payableAmount.toLocaleString(),
                                "원"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {})
        ]
    });
};
export default BooksOrderSummary;
